import Link from 'next/link';
import { getFAQLink } from '@/helpers/utils/siteUtils';

const EstimatedShipping = () => {
  return (
    <section>
      <p className="pb-3 pt-1 text-sm font-semibold leading-3">Estimated Shipping</p>
      <section className="text-sm font-normal leading-4">
        <section>
          <p className="pb-3">
            <strong>Standard:</strong> Delivered in 5-7 business days (after credit approval and order processing).
          </p>
          <p className="pb-3">
            <strong>Priority:</strong> Delivered in 3-5 business days (after credit approval and order processing). This
            service costs an additional $10 per order.
          </p>
          <p className="pb-3">
            <strong>Express:</strong> Delivered in 1-3 business days (after credit approval and order processing). This
            service costs an additional $20 per order.
          </p>
          <p className="pb-3">
            <strong>Heavyweight and Oversized Items:</strong> These items are designated with an alphabetic code in the
            product description and require additional costs.{' '}
            <Link target="_blank" href={getFAQLink('/help-center/faq/international-shipping')} className="underline">
              Click here
            </Link>{' '}
            to view alphabetic code pricing table. There may be some shipping restrictions on heavyweight and oversized
            delivery to AK, HI, and all U.S. Terr. and APO/FPO addresses.
          </p>
          <p className="pb-3">
            Please allow 1-2 additional business days for delivery to AK, HI, and all U.S. Terr. and APO/FPO addresses.
          </p>
          <p>
            <strong>Note:</strong> Shipping method selection is made during checkout. For more shipping information,{' '}
            <Link target="_blank" href={getFAQLink('/help-center/topic/shipping')} className="underline">
              click here
            </Link>
            .
          </p>
        </section>
      </section>
    </section>
  );
};

export default EstimatedShipping;
